import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/**
 * @description - Validates if a given date string is valid and after 0001-01-01.
 * @param date - The input date (string or Date).
 * @returns true if valid, false otherwise.
 */
export function isValidAppDate(
  date: string | Date | null | undefined
): boolean {
  try {
    if (!date) return false;

    const parsed = dayjs.utc(date);
    return parsed.isValid() && parsed.isAfter(dayjs.utc("0001-01-01"));
  } catch {
    return false;
  }
}
